/**
 * @generated SignedSource<<6c420342a53206a4c3edf48b10665fdf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetRoutinePositivePercentageScreen_routine$data = {
  readonly id: string;
  readonly inProgressOccasion: {
    readonly id: string;
    readonly sequenceNumber: number;
  } | null;
  readonly lastCompletedOccasion: {
    readonly id: string;
    readonly percentage: number | null;
    readonly sequenceNumber: number;
  } | null;
  readonly title: string;
  readonly " $fragmentType": "WidgetRoutinePositivePercentageScreen_routine";
};
export type WidgetRoutinePositivePercentageScreen_routine$key = {
  readonly " $data"?: WidgetRoutinePositivePercentageScreen_routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutinePositivePercentageScreen_routine">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequenceNumber",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetRoutinePositivePercentageScreen_routine",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineOccasion",
      "kind": "LinkedField",
      "name": "inProgressOccasion",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineOccasion",
      "kind": "LinkedField",
      "name": "lastCompletedOccasion",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "percentage",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};
})();

(node as any).hash = "0c1b823d022438573f285c90c65d680f";

export default node;
